import React, { useState, useContext, Fragment } from "react";
import AppContext from "../../container/context";
import api from "../../services/api";
import Form from "../../components/form";
import ActionTable from "../../components/table/ActionTable";
import { Box, CircularProgress } from "@mui/material";
import { mergeParams } from "../../helpers/helpers";

export default function NaoIniciados({ history, location }) {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [registros, setRegistros] = useState([]);
  const [filtros, setFiltros] = useState(
    mergeParams({ nome: "", escola: "", unidade: "" }, location)
  );

  const listar = (filtrosEnviar = filtros) => {
    setCarregando(true);
    setFiltros(filtrosEnviar);

    api
      .get("acompanhamento/naoIniciados", filtrosEnviar)
      .then((registros) => {
        setRegistros(registros);
        setCarregando(false);
      })
      .catch((e) => {
        notification(
          "error",
          "Não foi possível listar os acompanhamentos. Verifique sua conexão e tente novamente."
        );
        setCarregando(false);
      });
  };

  const abrirAcompanhamento = (registro) => {
    history.push(
      `/app/acompanhamento/${registro.unidadeId}/${registro.profissionalId}`
    );
  };

  const camposfiltros = (filtros) => {
    return {
      profissional: {
        label: "Nome",
        type: "text",
        space: 4,
        value: filtros.profissional,
      },
      escola: {
        label: "Escola",
        type: "text",
        space: 4,
        value: filtros.escola,
      },
      unidade: {
        label: "Unidade",
        type: "text",
        space: 4,
        value: filtros.unidade,
      },
    };
  };

  const fFiltros = {
    title: "Filtros",
    form: camposfiltros(filtros),
    submit: {
      label: "Buscar",
      action: listar,
    },
    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Não iniciados",
    onLineClick: abrirAcompanhamento,
    columns: [
      {
        label: "Profissional",
        name: "usuarioNome",
        style: { fontWeight: "bolder" },
      },
      {
        label: "Escola",
        name: "escolaNome",
      },
      {
        label: "Ciclo",
        name: "cicloNome",
      },
      {
        label: "Unidade",
        name: "unidadeTitulo",
      },
    ],
    array: registros,
  };

  return (
    <>
      <Form formData={fFiltros} />
      {carregando ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </>
  );
}
